import React from 'react'
import { Link } from 'react-router-dom'
import Advertice_1 from '../../../assets/images/home_page_5/advertise/01.png'
import Advertice_2 from '../../../assets/images/home_page_5/advertise/02.png'

const Advertise = () => {
    return (
        <>
            <section id="advertise-five" className="advertise-five-main-block">
                <div className="container">
                    <div className="advertise-one-block-five">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="home-five-banner-dtl">
                                    <h6 className="home-five-sub-title">
                                        Exclusive Offer{" "}
                                        <span className="badge text-bg-primary">-20%Off</span>
                                    </h6>
                                    <h2 className="home-five-title">Super fast performance</h2>
                                    <p>
                                        We have prepared special discounts for you on electronic products.
                                        Don't miss these opportunities...
                                    </p>
                                    <Link to="#" title="" className="btn btn-primary-five">
                                        {" "}
                                        Shop now <i className="flaticon-right-arrow" />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="advertise-five-img-block">
                                    <div className="advertise-five-img">
                                        <img
                                            src={Advertice_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                    <div className="advertise-five-img">
                                        <img
                                            src={Advertice_2}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Advertise
